import 'core-js/features/array/find';
import 'core-js/features/typed-array/uint8-clamped-array';
import './polyfills/prepend.polyfill';
import CIResponsive from './ci.service';


window.CIResponsive = CIResponsive;
